module.exports = __webpack_public_path__ + "static/media/Flashbang-Rafiki-cards_hearts-king.1b517ddd.svg";